import {_ as _svelte, locale as _svelteLocale} from 'svelte-i18n';
import {get} from 'svelte/store';

export const _ = (key, settings = {}) => {
    // console.log('key', key, i18next.t(key, settings));

    // if (typeof i18next === 'undefined') {
    //     return key
    // }
    //
    // return i18next.t(key, settings)

    // // This is workaround for i18next
    // let locale = require('../locale/pl/geoanalytics.json');
    // if (typeof locale[key] !== 'undefined') {
    //     return locale[key];
    // }

    // svelte-i18n RZUCA, gdy locale nie jest jeszcze ustawione, a `init()` siedzi wylacznie
    // w `src/locale/loadLocalesAsync.js`, ktory ciagnie dopiero `App.svelte`. Kazdy modul wolajacy
    // `_()` wczesniej (albo test unitowy, ktory nie laduje App) wywracalby sie na wyjatku zamiast
    // oddac tekst. Zwracamy wtedy sam klucz - to jest juz kontrakt tego wrappera: klucze sa polskie,
    // wiec brak tlumaczenia jest neutralny (patrz komentarz w FilterTools.translateFilterItem).
    if (get(_svelteLocale) == null) {
        return key;
    }

    return get(_svelte)(key, settings); // FIXME: add i18next support
}
